import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ChargeAccountsPrintsModel } from 'src/app/models/invoicing/charge-accounts-prints.model';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { InvoicesPrintModel } from 'src/app/models/invoicing/invoices-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChargeAccountService {

  constructor(private _httpClient: HttpClient) { }

  getChargeAccountById(chargeAccountId: number): Observable<InvoiceModel> {
    return this._httpClient.get<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetChargeAccountById}/${chargeAccountId}`);
  }

  createChargeAccount(chargeAccountContract: InvoiceModel): Observable<InvoiceModel> {
    return this._httpClient.post<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.CreateChargeAccount}`,
      chargeAccountContract);
  }

  updateChargeAccount(chargeAccountContract: InvoiceModel): Observable<InvoiceModel> {
    return this._httpClient.put<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.UpdateChargeAccount}`,
      chargeAccountContract);
  }

  deleteChargeAccount(chargeAccountId: number): Observable<InvoiceModel> {
    return this._httpClient.delete<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.DeleteChargeAccount}/${chargeAccountId}`);
  }

  setStateChargeAccount(chargeAccountId: number): Observable<InvoiceModel> {
    return this._httpClient.put<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.SetChargeAccountState}/${chargeAccountId}`,
      null);
  }

  blockChargeAccount(chargeAccountId: number): Observable<InvoiceModel> {
    return this._httpClient.put<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.BlockChargeAccount}/${chargeAccountId}`, null);
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetPermissionPrint}`);
  }

  printChargeAccounts(itemFilters: Array<ItemFilterModel>): Observable<Array<ChargeAccountsPrintsModel>> {
    return this._httpClient.post<Array<ChargeAccountsPrintsModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.PrintChargeAccounts}`, itemFilters);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetColumnsForGeneralConsultation}`);
  }

  getAllBussinessDocumentsTypesForSelectAsync(branchId: number, enterpriseId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId).set('enterpriseId', enterpriseId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetAllBussinessDocumentsTypesForSelectAsync}`,
      { params: params }
    );
  }

  getAllConceptForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetAllConceptForSelectAsync}`,);
  }

  getCostCentersForSelectAsync(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetCostCentersForSelectAsync}`,
      { params: params }
    );
  }

  getChargeAccountsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetAllChargeAccountsWithPagination}`,
      filters, { params: params }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getPrintChargeAccountForFormat(chargeAccountId: number): Observable<InvoicesPrintModel> {
    return this._httpClient.get<InvoicesPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetPrintChargeAccountForFormat}/${chargeAccountId}`);
  }

  getChargeAccountByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<InvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    params = params.set('consecutive', consecutive);
    return this._httpClient.get<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetChargeAccountByKeys}`, { params: params });
  }

  getFirstChargeAccountByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number): Observable<InvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetFirstChargeAccountByKeys}`, { params: params });
  }

  getLastChargeAccountByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number): Observable<InvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetLastChargeAccountByKeys}`, { params: params });
  }

  getPreviusChargeAccountByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<InvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    params = params.set('consecutive', consecutive);
    return this._httpClient.get<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetPreviusChargeAccountByKeys}`, { params: params });
  }

  getNextChargeAccountByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<InvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    params = params.set('consecutive', consecutive);
    return this._httpClient.get<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetNextChargeAccountByKeys}`, { params: params });
  }

  copyChargeAccount(idChargeAccountDestinity: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<InvoiceModel> {
    return this._httpClient.post<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.CopyChargeAccount}/${idChargeAccountDestinity}/${bussinessDocumentsTypeId}/${consecutive}`, null);
  }

  attachFilesToChargeAccount(chargeAccountId: number, files: FormData): Observable<Array<string>> {
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.AttachFilesToChargeAccount}/${chargeAccountId}`, files);
  }

  getFilesToChargeAccount(chargeAccountId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetFilesToChargeAccount}/${chargeAccountId}`);
  }

  downloadFileToChargeAccount(chargeAccountId: number, file: string): Observable<HttpEvent<Blob>> {
    const itemFilterResponse = new ItemFilterModel("file", null, chargeAccountId, file);
    return this._httpClient.request(new HttpRequest('POST', `${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.DownloadFileToChargeAccount}`,
      itemFilterResponse, { reportProgress: true, responseType: 'blob' }));
  }

  deleteFilesToChargeAccount(chargeAccountId: number, file: string): Observable<Array<string>> {
    const itemFilterResponse = new ItemFilterModel("file", null, chargeAccountId, file);
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.DeleteFilesToChargeAccount}`,
      itemFilterResponse);
  }

  getPermissionAnnulChargeAccount(chargeAccountId: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.GetPermissionAnnulChargeAccount}/${chargeAccountId}`);
  }

  printsChargeAccounts(invoiceId: number, consecutiveInitial: number | null, consecutiveFinal: number | null, print: boolean): Observable<Array<ChargeAccountsPrintsModel>> {
    let params = new HttpParams()
    params = params.set('invoiceId', invoiceId.toString());
    params = params.set('print', print);
    if (consecutiveInitial !== null)
      params = params.set('consecutiveInitial', consecutiveInitial.toString());
    if (consecutiveFinal !== null)
      params = params.set('consecutiveFinal', consecutiveFinal.toString());
    return this._httpClient.get<Array<ChargeAccountsPrintsModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.PrintsChargeAccounts}`,
      { params: params }
    );
  }

  annulChargeAccount(chargeAccountContract: InvoiceModel): Observable<InvoiceModel> {
    return this._httpClient.put<InvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccount.AnnulChargeAccount}`,
      chargeAccountContract);
  }
}
